// extracted by mini-css-extract-plugin
module.exports = {"content":"accordionsSection_content__jyT5R","image":"accordionsSection_image__U7Onr"};